module.exports = new __parcel__URL__("crash-team-racing.0076f535.jpg").toString();